export const variant1 = 'variant1';
export const variant2 = 'variant2';
export const variant3 = 'variant3';
export const variant4 = 'variant4';
export const AVAILABLE_TRANSMISSIONS_FIELD_NAME = 'hasTransmissions';
export const INTERIOR_MATERIAL_FIELD_NAME = 'interiorMaterial';
export const DRIVE_TRAIN_FIELD_NAME = 'drivetrain';
export const DESIGN_FEATURES_FIELD_NAME = 'designFeatures';
export const TRANSMISSIONS_FIELD_NAME = 'Transmission';
